import { Wrench, QrCode, NotepadText } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface SubMenuItem {
  translationKey: string
  href: string
  icon?: LucideIcon
}

export interface MenuItem {
  translationKey: string
  href?: string
  icon: LucideIcon
  subItems?: SubMenuItem[]
}

export const menuConfig: MenuItem[] = [
  {
    translationKey: 'navigation.toolManagement',
    href: '/tool-management',
    icon: Wrench,
  },
  {
    translationKey: 'navigation.qrCodes',
    href: '/qrcode',
    icon: QrCode,
  },
  {
    translationKey: 'navigation.summarization',
    href: '/summarization',
    icon: NotepadText,
  },
]

export const defaultExpandedMenus: string[] = []
